import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../ThemeContext';

const SignInPromptModal = ({ show, onHide }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const handleSignIn = () => {
    onHide();
    navigate('/auth');
  };

  const handleSignUp = () => {
    onHide();
    navigate('/auth?signup=true');
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header
        closeButton
        style={{
          background: theme === 'dark'
            ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)'
            : 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
          borderBottom: `1px solid ${theme === 'dark' ? '#334155' : '#bfdbfe'}`,
        }}
      >
        <Modal.Title className="d-flex align-items-center gap-2">
          <span
            style={{
              background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
              borderRadius: '8px',
              width: 36,
              height: 36,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <i className="fas fa-lock-open text-white" style={{ fontSize: '16px' }} />
          </span>
          <span style={{ color: 'var(--text-main)', fontWeight: 700, fontSize: '1.1rem' }}>
            Unlock Full Outage Forecasts
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '1.5rem' }}>
        <p style={{ color: 'var(--text-main)', marginBottom: '1.25rem', fontSize: '0.95rem' }}>
          Create a free account to access more features:
        </p>

        <ul className="list-unstyled" style={{ display: 'flex', flexDirection: 'column', gap: '0.65rem', marginBottom: '1.5rem' }}>
          {[
            { icon: 'fa-map-marked-alt', text: 'Drill into individual states for county-level forecasts' },
            { icon: 'fa-hashtag',        text: 'Exact customer outage numbers in the heatmap' },
            { icon: 'fa-cloud-sun-rain', text: 'Detailed hourly weather data per county' },
            { icon: 'fa-list-ol',        text: 'Full Top 10 state & county leaderboards' },
            { icon: 'fa-chart-line',     text: 'Weekly outage trend charts' },
          ].map(({ icon, text }) => (
            <li key={icon} className="d-flex align-items-start gap-2">
              <span
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  marginTop: 1,
                }}
              >
                <i className={`fas ${icon} text-white`} style={{ fontSize: '11px' }} />
              </span>
              <span style={{ color: 'var(--text-main)', fontSize: '0.9rem', lineHeight: '1.4' }}>{text}</span>
            </li>
          ))}
        </ul>

        <div className="d-grid gap-2">
          <Button
            onClick={handleSignUp}
            style={{
              background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
              border: 'none',
              fontWeight: 600,
              padding: '0.6rem',
              borderRadius: 8,
            }}
          >
            <i className="fas fa-user-plus me-2" />
            Create Free Account
          </Button>
          <Button
            variant={theme === 'dark' ? 'outline-light' : 'outline-secondary'}
            onClick={handleSignIn}
            style={{ fontWeight: 500, padding: '0.6rem', borderRadius: 8 }}
          >
            <i className="fas fa-sign-in-alt me-2" />
            Sign In
          </Button>
        </div>
      </Modal.Body>

      <Modal.Footer
        className="justify-content-center"
        style={{
          borderTop: `1px solid ${theme === 'dark' ? '#334155' : '#e2e8f0'}`,
          padding: '0.75rem',
        }}
      >
        <button
          className="btn btn-link text-main text-decoration-underline small p-0"
          onClick={onHide}
          style={{ fontSize: '0.8rem' }}
        >
          Continue exploring in guest mode
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SignInPromptModal;
